// import PropTypes from 'prop-types';
import { useState, Suspense } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Tooltip, Typography, CircularProgress, ButtonBase } from '@mui/material';

// project imports
import ProfileSection from './ProfileSection';

// assets
import HiredrateAppBar from 'ui-component/appBar/HiredrateAppBar';
import CompanyLogo from '../LogoSection/CompanyLogo';
import { lazy } from 'react';
import { Link } from 'react-router-dom';
import { MENU_OPEN, MENU_SELECT } from 'store/actions';
import config from 'config';

// Lazy loading for components
const MessagePopover = lazy(() => import('./MessageSection/MessagePopover'));
const NotificationSection = lazy(() => import('./NotificationSection'));

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = () => {
  const theme = useTheme();
  const [menuHL, setMenuHL] = useState(true);
  const { companyLogo, companyName } = useSelector((state) => state.account);
  const [runTour, setRunTour] = useState(0);
  const defaultId = useSelector((state) => state.customization.defaultId);

  const updateRunValue = (value) => {
    console.log('upvalue', value);
    setRunTour(value);
  };


  const handleMenuClick = () => {
    setMenuHL(false);
  };

  const handleTopMenuClick = () => {
    setMenuHL(true);
  };
  const dispatch = useDispatch();


  return (
    <>
      {/* header container */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center', // Align items vertically center
          justifyContent: 'space-between', // Spread items horizontally
          width: '100%',
          padding: theme.spacing(1, 2), // Adjust padding as needed
          [theme.breakpoints.down('md')]: {
            flexDirection: 'column', // Stack items vertically on small screens
            alignItems: 'stretch', // Stretch items to full width on small screens
          },
        }}
      >
        {/* logo & toggler button */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            width: 228,
            [theme.breakpoints.down('md')]: {
              width: '100%',
              justifyContent: 'center',
            },
          }}
        >
          <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
            <ButtonBase disableRipple onClick=
              {() => {
                dispatch({
                  type: MENU_OPEN, id: defaultId
                })
                dispatch({
                  type: MENU_SELECT,
                  payload: {
                    menuItem: 'Job Positions',
                  },
                });
              }

              } component={Link} to={config.defaultPath}>

              {companyName ?
                <Tooltip title={companyName}>
                  {companyLogo != null ?
                    <CompanyLogo src={companyLogo} />
                    :
                    <Typography variant="subtitle1" sx={{ fontWeight: 700, fontSize: 14 }}>
                      {companyName.length > 30 ? `${companyName.slice(0, 30)}...` : companyName}
                    </Typography>}
                </Tooltip>
                : null}
            </ButtonBase>
          </Box>

        </Box>

        {/* header search */}


        {/* notification & profile */}
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: "flex-end" }}>
          <HiredrateAppBar runTour={runTour} setRunValue={updateRunValue} highlightMenu={menuHL} handleTopMenuClick={handleTopMenuClick} />

          <Suspense fallback={<CircularProgress size={24} />}>
            <MessagePopover />
          </Suspense>

          <Suspense fallback={<CircularProgress size={24} />}>
            <NotificationSection />
          </Suspense>
          <ProfileSection handleMenuClick={handleMenuClick} runTour={runTour} setRunValue={updateRunValue} />
        </Box>
      </Box>
    </>
  );
};

export default Header;
